// src/redux/sagas/modifiersSaga.ts
import { call, put, takeLatest, select, all } from 'redux-saga/effects';
import {
  fetchModifiersRequest,
  fetchModifiersSuccess,
  fetchModifiersFailure,
  ModifierGroup,
  ModifierOption,
} from '../slices/modifiersSlice';
// import { RootState } from '../store';
import ENDPOINTS from '../../api/endpoints';
import { request } from '../../api/request';

function* fetchModifiersSaga(): Generator<any, void, any> {
  try {
    const groupsUrl = `${ENDPOINTS.API_V2_BASE_URL}${ENDPOINTS.MODIFIER_GROUPS_API_PATH}`;
    const optionsUrl = `${ENDPOINTS.API_V2_BASE_URL}${ENDPOINTS.MODIFIER_OPTIONS_API_PATH}`;

    // Fetch both APIs in parallel
    const [groupsResponse, optionsResponse] = yield all([
      call(request, {
        url: groupsUrl,
        method: 'GET',
        headers: {
          'restaurant-id': '7cdb36d9-c51b-473e-9a9f-cfc468ee6d0b',
        },
        requiresRestaurantId:false
      }),
      call(request, {
        url: optionsUrl,
        method: 'GET',
        headers: {
           'restaurant-id': '7cdb36d9-c51b-473e-9a9f-cfc468ee6d0b',
        },
         requiresRestaurantId:false
      }),
    ]);

    if (groupsResponse.data?.success && optionsResponse.data?.success) {
      yield put(
        fetchModifiersSuccess({
          groups: groupsResponse.data.data as ModifierGroup[],
          options: optionsResponse.data.data as ModifierOption[],
        })
      );
    } else {
      const errorMessage =
        groupsResponse.data?.message || optionsResponse.data?.message || 'Failed to fetch modifiers';
      yield put(fetchModifiersFailure(errorMessage));
    }
  } catch (error: any) {
    yield put(fetchModifiersFailure(error.message || 'Failed to fetch modifiers'));
  }
}

export function* modifiersSaga() {
  yield takeLatest(fetchModifiersRequest.type, fetchModifiersSaga);
}
